import { axiosInstance } from '../common/api';

export const getTeam = (pageNumber, pageSize, search) => {
  const url = `/team/?pageNumber=${pageNumber + 1}&pageSize=${pageSize}&search=${search}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getAllManagers = () => {
  const url = `/user/managers`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getAllEmployee = () => {
  const url = `/user/employee`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getAllUsers = (role, projectId) => {
  let url = '/user/all';
  if (role && projectId) {
    url += `?role=${role}&projectId=${projectId}`;
  }
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getTeamMembers = () => {
  const url = `/team/getmembers`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const createTeam = (data) => {
  const url = `/team/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateTeam = (id, data) => {
  const url = `/team/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteTeam = (id) => {
  const url = `/team/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

